// web-staking-estimator-frontend/src/components/common/LoadingOverlay.js
import React from "react";

/**
 * Loading overlay with spinner and message
 * Used to block interaction while async operations are in progress
 */
export function LoadingOverlay({ message, ariaLabel }) {
  return (
    <div
      className="mapOverlay"
      role="status"
      aria-live="polite"
      aria-atomic="true"
      aria-label={ariaLabel || message}
    >
      <div className="spinner" aria-hidden />
      <div className="overlayText">{message}</div>
    </div>
  );
}
